/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import routes from 'routes';

import MenuItem from '../MenuItem';

import { ReactComponent as AnalyticsIcon } from 'icons/analytics.svg';
import { ReactComponent as CreatorsIcon } from 'icons/creators.svg';
import { ReactComponent as FinancialsIcon } from 'icons/cashflow.svg';
import { ReactComponent as InvoicesIcon } from 'icons/invoices.svg';
import { ReactComponent as InventoryIcon } from 'icons/inventory.svg';
import { ReactComponent as ResourcesIcon } from 'icons/resources.svg';
import { ReactComponent as SalesIcon } from 'icons/sales.svg';
import { ReactComponent as ScheduleIcon } from 'icons/schedule.svg';
import { ReactComponent as SponsorsIcon } from 'icons/sponsors.svg';
import { ReactComponent as StatementsIcon } from 'icons/statements.svg';
import { ReactComponent as VideosIcon } from 'icons/videos.svg';

const baseCSS = {
  fill: 'inherit',
  width: '22px',
  height: '22px',
  position: 'relative',
  top: '-1px',
};

const Navigation = ({ 
  isCreator, 
  isReadOnlyCreator,
  isPhone, 
  isSponsor, 
  isLoggedIn, 
  isStaff, 
}) => {
  let schedule;
  if (isLoggedIn && (isCreator || isStaff)) {
    schedule = (
      <MenuItem
        key={routes.Schedule.Index.path}
        to={routes.Schedule.Index.path}
        icon={<ScheduleIcon css={baseCSS} />}
        text={routes.Schedule.Index.title}
      />
    );
  }

  let users;
  if (isStaff) {
    users = (
      <MenuItem
        key={routes.Creators.Index.path}
        to={routes.Creators.Index.path}
        icon={<CreatorsIcon css={baseCSS} />}
        text={routes.Creators.Index.title}
      />
    );
  }

  let sponsors;
  if (isStaff || (isCreator && !isReadOnlyCreator)) {
    sponsors = (
      <MenuItem
        key={routes.Sponsors.Index.path}
        to={routes.Sponsors.Index.path}
        icon={<SponsorsIcon css={baseCSS} />}
        text={routes.Sponsors.Index.title}
      />
    );
  }

  let financials;
  if (isStaff) {
    financials = (
      <MenuItem
        key={routes.Financials.Index.path}
        to={routes.Financials.Index.path}
        icon={<FinancialsIcon css={baseCSS} />}
        text={routes.Financials.Index.title}
      />
    );
  }

  let statements;
  if (isLoggedIn && (isStaff || isCreator)) {
    statements = (
      <MenuItem
        key={routes.Statements.Index.path}
        to={isCreator ? routes.Statements.Index.path + '#next-statement' : routes.Statements.Index.path}
        icon={<StatementsIcon css={baseCSS} />}
        text={routes.Statements.Index.title}
      />
    );
  }

  let sales;
  if (isStaff) {
    sales = (
      <MenuItem
        key={routes.Sales.Index.path}
        to={isStaff ? routes.Sales.Index.path + '#drafts' : routes.Sales.Index.path}
        icon={<SalesIcon css={baseCSS} />}
        text={routes.Sales.Index.title}
      />
    );
  }

  let sponsorships;
  if (isSponsor) {
    sponsorships = (
      <MenuItem
        key={routes.Sponsorships.Index.path}
        to={routes.Sponsorships.Index.path}
        icon={<SalesIcon css={baseCSS} />}
        text={routes.Sponsorships.Index.title}
      />
    );
  }

  let invoices;
  if (isStaff || isSponsor) {
    invoices = (
      <MenuItem
        key={routes.Invoices.Index.path}
        to={isStaff ? routes.Invoices.Index.path + '?status=unpaid' : routes.Invoices.Index.path}
        icon={<InvoicesIcon css={baseCSS} />}
        text={routes.Invoices.Index.title}
      />
    );
  }

  let ios;
  if (isSponsor) {
    ios = (
      <MenuItem
        key={routes.InsertionOrder.Index.path}
        to={routes.InsertionOrder.Index.path}
        icon={<StatementsIcon css={baseCSS} />}
        text={routes.InsertionOrder.Index.title}
      />
    );
  }

  let inventory;
  if (isStaff || isSponsor) {
    inventory = (
      <MenuItem
        key={routes.Inventory.Index.path}
        to={routes.Inventory.Index.path + '#youtube'}
        icon={<InventoryIcon css={baseCSS} />}
        text={routes.Inventory.Index.title}
      />
    );
  }

  let analytics;
  if (isLoggedIn && (isCreator || isStaff || isSponsor)) {
    analytics = (
      <MenuItem
        key={routes.Analytics.Index.path}
        to={isSponsor || isStaff ? routes.Analytics.Index.path + '#youtube' : routes.Analytics.Index.path + '#analytics'}
        icon={<AnalyticsIcon css={baseCSS} />}
        text={routes.Analytics.Index.title}
      />
    );
  }

  let nebula;
  if (isLoggedIn && isStaff) {
    nebula = (
      <MenuItem
        key={routes.Nebula.Index.path}
        to={routes.Nebula.Index.path}
        icon={<CreatorsIcon css={baseCSS} />}
        text={`Nebula`}
      />
    );
  }

  let resources;
  if (isLoggedIn && (isStaff || (isCreator && !isReadOnlyCreator))) {
    resources = (
      <MenuItem
        key={routes.Resources.Index.path}
        to={routes.Resources.Index.path + '#free-stuff'}
        icon={<ResourcesIcon css={baseCSS} />}
        text={routes.Resources.Index.title}
      />
    );
  }

  let videos;
  if (isLoggedIn && (isCreator || isStaff)) {
    videos = (
      <MenuItem
        key={routes.Videos.Index.path}
        to={routes.Videos.Index.path}
        icon={<VideosIcon css={baseCSS} />}
        text={routes.Videos.Index.title}
      />
    );
  }

  return (
    <nav
      style={{
        marginTop: isPhone ? 0 : 36,
      }}
    >
      {schedule}
      {users}
      {sponsors}
      {financials}
      {statements}
      {sales}
      {sponsorships}
      {ios}
      {invoices}
      {inventory}
      {analytics}
      {resources}
      {videos}
      {nebula}
    </nav>
  );
};

Navigation.propTypes = {};

export default Navigation;
